module.exports = __webpack_public_path__ + "src/assets/img/icon_1.2bc6b307.svg";